var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Tooltip, tooltipClasses } from "@mui/material";
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
export const TypographyWithOverflowTooltip = ({ tooltipProps = {}, typographyProps = {}, maxWidth = "none", children, }) => {
    const textRef = useRef(null);
    const [isOverflowed, setIsOverflowed] = useState(false);
    const checkOverflow = useCallback(() => {
        if (textRef.current) {
            const { scrollWidth, clientWidth } = textRef.current;
            setIsOverflowed(scrollWidth > clientWidth);
        }
    }, []);
    useLayoutEffect(() => {
        const node = textRef.current;
        if (!node)
            return;
        const resizeObserver = new ResizeObserver(() => {
            window.requestAnimationFrame(checkOverflow);
        });
        resizeObserver.observe(node);
        checkOverflow();
        return () => {
            resizeObserver.disconnect();
        };
    }, [checkOverflow]);
    // Re-check overflow when children change (in case the content updates)
    useEffect(() => {
        checkOverflow();
    }, [children, checkOverflow]);
    return (_jsx(CustomWidthTooltip, Object.assign({ title: isOverflowed ? children : "", maxWidth: maxWidth, disableHoverListener: !isOverflowed, placement: "top", classes: tooltipClasses }, tooltipProps, { children: _jsx(Typography, Object.assign({ ref: textRef, noWrap: true, sx: [
                {
                    display: "block",
                    textOverflow: "ellipsis",
                },
                ...(Array.isArray(typographyProps.sx) ? typographyProps.sx : [typographyProps.sx]),
            ] }, typographyProps, { children: children })) })));
};
const CustomWidthTooltip = styled((_a) => {
    var { className, maxWidth } = _a, props = __rest(_a, ["className", "maxWidth"]);
    return (_jsx(Tooltip, Object.assign({}, props, { classes: { popper: className } })));
})(({ maxWidth }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: maxWidth,
    },
}));
